/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Sidebar Menu Customizations */

$(function(){
  $('.Sidebar-Cart').click(function(){
    $('#sidebar-menu .Drawer__Close').trigger('click');
  });
  
  $('.SidebarMenu__Nav--primary > .Collapsible > .Collapsible__Button').each(function(){
      $(this).click(function(){
      if($(this).attr('aria-expanded') == "false"){
          $(this).parents('.SidebarMenu__Nav--primary').addClass('active-subnav');  
      }else{
         $(this).parents('.SidebarMenu__Nav--primary').removeClass('active-subnav');
      }
    });
  });
  
  
    $('.SidebarMenu__Nav--primary .Collapsible__Inner .Collapsible > .Collapsible__Button').each(function(){
      $(this).click(function(){
      if($(this).attr('aria-expanded') == "false"){
          $(this).parents('.Collapsible__Inner').addClass('active-subnav');  
      }else{
         $(this).parents('.Collapsible__Inner').removeClass('active-subnav');
      }
    });
  });
  
  
  $('#sidebar-menu .Drawer__Close').click(function(){
     $('#sidebar-mega-menus .mega-menu').attr('aria-hidden', 'true');
      $('.SidebarMenu__Nav--primary .Collapsible__Inner .Collapsible__Button[aria-expanded="true"]').trigger('click');
    
  });
  
  

  
  $('.SidebarMenu__Nav--primary .Collapsible__Inner .Collapsible__Button[data-action="toggle-collapsible"]').each(function(){
    $(this).click(function(){
      
      $('#sidebar-mega-menus .mega-menu').attr('aria-hidden', 'true');
      	var menu_id = $(this).data('title');
        var aria_state = $(this).attr('aria-expanded');
        var final_menu_id = '#sidebar-mega-menus .mega-menu[data-title="'+menu_id+'"]';

          if(aria_state == 'false'){
            $(final_menu_id).attr('aria-hidden', 'false');
          } 
    });
  });
  
  
  $('#sidebar-mega-menus .mega-contents .Link').hover(function(){
    	$(this).parents('.mega-menu').find('.collection-image').removeClass('active');
		var image_id = $(this).attr('href');
        var final_image_id = '#sidebar-mega-menus .collection-image[data-id="'+image_id+'"]';
  		$(final_image_id).addClass('active');	
    
  }, function(){
       
  });
  
  
  
  if($('.template-index').length > 0){
     homepage_sidebar();
    
    $(window).resize(function(){
      homepage_sidebar();
    });
  }
                     
   function homepage_sidebar(){
     var w_width = $('body').width();
     
     if(w_width > 768){
       $('#sidebar-menu').attr('aria-hidden', 'false');
     }else{
        $('#sidebar-menu').attr('aria-hidden', 'true');
     }
     
     
      
  }
  
  
  
})


/* Product Reviews */
$(function(){

  if($('.product-reviews-section .spr-reviews').length > 0){
    setTimeout(function(){
      $('.product-reviews-section .spr-pagination').remove();
      $('.product-reviews-section .spr-reviews').flickity({
        prevNextButtons: false,
        cellAlign: 'left',
        wrapAround: true
       });
    }, 1000);
    
    setTimeout(function(){
      if($('.spr-reviews.flickity-enabled').length == 0){
        $('.product-reviews-section .spr-pagination').remove();
        $('.product-reviews-section .spr-reviews').flickity({
          prevNextButtons: false,
          cellAlign: 'left',
          wrapAround: true
         });
      }
    }, 2000);
    
    
    setTimeout(function(){
       if($('.spr-reviews.flickity-enabled').length == 0){
        $('.product-reviews-section .spr-pagination').remove();
        $('.product-reviews-section .spr-reviews').flickity({
          prevNextButtons: false,
          cellAlign: 'left',
          wrapAround: true
         });
       }
    }, 3000);
    

  }
});


/* Blog Full Width Images */
$(function(){
  if($('.Article__Body p img').length > 0){

    setTimeout(function(){
    $('.Article__Body p img').each(function(){
       var src_size = $(this).attr('src');
      
      if( src_size.includes('2048')){
       $(this).addClass('big-image');
      }
    })
    }, 1000);
    
  }
});


/* Background Video Overlay */
$(function(){
  if($('.background-video-overlay:first-child').length > 0){
    $(window).scroll(function() {
      
      if($(window).width() > 640){
        var scroll = $(window).scrollTop();
        var width = 60 + scroll*.03;
        var width_final = width + "%";
        $('.background-video-overlay .background-mask').css({'width': width_final });
      }
	});
  }
});


/* Upsell Product */
$(function(){
  setTimeout(function(){
   upsell_init();
  }, 1000);
  
  setTimeout(function(){
   upsell_init();
  }, 2000);
  

  document.addEventListener('theme:loading:end', function() {
    setTimeout(function(){
     upsell_init();
    }, 1000);
    
    setTimeout(function(){
     upsell_init();
    }, 2000);
    

 });
  
  
  

 
  
  $('.cart-upsell .ProductForm__AddToCart').click(function(e){
    e.preventDefault();
    
    var upsell_id = $('.AddToCart_Upsell').data('variant');
    var upsell_message = $("#card-message").val();
    
 
    
       fetch('/cart/add.js', {
         body: JSON.stringify({
           id: upsell_id,
           quantity: 1,
           properties:{
             'Card Message': upsell_message
           },
         }),
         credentials: 'same-origin',
         method: 'POST',
         headers: {
           'Content-Type': 'application/json',
           'X-Requested-With': 'XMLHttpRequest' 
         }
       }).then(function (response) {
       	 document.dispatchEvent(new CustomEvent('product:added', {
             bubbles: true,
             detail: {
               variant: upsell_id,
               quantity: 1,
               properties:{
                'Card Message': upsell_message
               },
             }
           }));
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
       });
    
    $('.cart-upsell').removeClass('active');
  
});
  
});

function upsell_init(){
  
  if($('.Cart_Upsell_CTA.cta-init').length == 0){
  $('.Cart_Upsell_CTA').click(function(){
        $('.cart-upsell').addClass('active');
  });

  $('.cart-upsell-close').click(function(){
      $('.cart-upsell').removeClass('active');
  });
     
    $('.Cart_Upsell_CTA').addClass('cta-init');
  }
}


/* Featured COllections Color */
$(function(){
  $('.featured-collections').each(function(){
    var bg_color = $(this).find('Section').data('section-color');
    $(this).addClass(bg_color);
  })

})

// Open external links in new tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}